import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface SalesChartProps {
  labels: string[];
  data: number[];
  currencySymbol?: string;
}

const SalesChart = ({ labels, data, currencySymbol = "£" }: SalesChartProps) => {
  const chartData = labels.map((label, index) => ({
    month: label,
    sales: data[index] ?? 0,
  }));

  return (
    <div className="bg-white rounded-xl shadow-md p-6 outline-none">
      <h2 className="text-lg font-semibold text-[#402B69] mb-4">
        Sales Overview
      </h2>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5E5E5" />
          <XAxis dataKey="month" stroke="#888888" />
          <YAxis stroke="#888888" />
          <Tooltip
            formatter={(value: any) => [`${currencySymbol}${value ?? 0}`, "sales"]}
            contentStyle={{ borderRadius: "8px", border: "1px solid #E5E5E5" }}
          />
          <Line
            type="monotone"
            dataKey="sales"
            stroke="#885ABB"
            strokeWidth={3}
            dot={{ r: 4 }}
            activeDot={{ r: 6, strokeWidth: 0 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesChart;
